import request from "../utils/request";

export async function getBlackList(payload) {
    let query = serialize(payload);
    return request.get("BlackList/List?" + query);
  }

  export async function createBlackList(newBlackList){
    return request.post("BlackList/Create",newBlackList);
  }

  export async function updateBlackList(blackList){
    return request.post("BlackList/Update",blackList);
  }

  export async function deleteBlackList(id){
    return request.delete('BlackList/Delete?id='+id);
  }


  function serialize(obj, prefix) {
    let str = [], p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        str.push((v !== null && typeof v === "object") ?
          serialize(v, k) :
          encodeURIComponent(k) + "=" + encodeURIComponent(v));
      }
    }
    return str.join("&");
  }